define('home/overrides/marionette.overrides',[
    'backbone-marionette',
], function (
    Marionette
) {
    'use strict';

    /**
      * New function, not an override.
      * This will rerender the model portion of the template for a composite view
      * but will not rerender the collection portion.
      */
    Marionette.CompositeView.prototype.rerenderModel = function () {
        var $itemViewContainer = this.$(this.itemViewContainer).detach();
        this.$el.html(this.renderModel());
        this.$(this.itemViewContainer).replaceWith($itemViewContainer);

        this.triggerMethod('render', this);
    };
});

